/* eslint-disable react/prop-types */
import React from 'react';
import MuiPagination from '@mui/material/Pagination';

const Pagination = ({ count, variant, shape, color, ...rest }) => (
  <MuiPagination count={count} variant={variant} shape={shape} color={color} {...rest} />
);

export default Pagination;
